// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"1427":"bc2f071b","1637":"9547b217","3207":"6ef8c86f","7142":"422db5db","8465":"bd80f86d"}[chunkId] + ".js";
};